var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.addComment($event)
        },
      },
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Comment", "label-for": "comment" } },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      id: "textarea-default",
                      placeholder: "Write your comment",
                      rows: "3",
                      required: "",
                    },
                    model: {
                      value: _vm.comment,
                      callback: function ($$v) {
                        _vm.comment = $$v
                      },
                      expression: "comment",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-between",
              attrs: { md: "12" },
            },
            [
              _c(
                "b-button",
                { attrs: { type: "submit", variant: "primary" } },
                [
                  _vm._v("Submit"),
                  _vm.loading
                    ? _c("b-spinner", { staticClass: "mx-2" })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }